/**
 * Check if any background values are set for any breakpoint
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import { BackgroundAttributes, ResponsiveBreakpoint } from '../../types';
import { hasBackgroundValues } from '../has-background-values';

/**
 * Check if any background values are set for any breakpoint
 */
export const hasAnyBackgroundValues = (
	attributes: BackgroundAttributes,
): boolean => {
	return [ 'desktop', 'tablet', 'mobile' ].some( ( breakpoint ) => {
		const values = attributes[ breakpoint as ResponsiveBreakpoint ];
		return values && hasBackgroundValues( values );
	} );
};
